import { useAddPhmsaReportExportJobMutation } from 'app/services/api/phmsa/phmsareport'
import { useExportJobContext } from 'common/contexts/useExportJobContext'

import { IExportPHMSAButtonProps } from './types'

const ExportPHMSAButton = ({ exportParams }: IExportPHMSAButtonProps) => {
  const [addPhmsaExportJob] = useAddPhmsaReportExportJobMutation()
  const { exportJob, isExporting, createDataExportJob } = useExportJobContext()

  return (
    <button
      className={[
        'ml-2 mt-2 h-10 w-32 rounded',
        'bg-lighthouseBlue',
        'font-semibold uppercase text-white',
        'disabled:opacity-50'
      ].join(' ')}
      disabled={isExporting || exportJob.isFetching}
      onClick={() =>
        createDataExportJob(addPhmsaExportJob, exportParams, 'PHMSA_Export')
      }
    >
      Export
    </button>
  )
}

export default ExportPHMSAButton
